//PubSub的action命名
export default {
    global: {
        onIframeKeydown: "onIframeKeydown", //iframe内键盘事件
        onIframeClick: "onIframeClick", //iframe内点击事件
        onLoadIMData: "onLoadIMData", //获取IM相关数据
    },
};
